/**
 * http配置
 */
import {Message,} from 'element-ui'
import store from '../store/index'
import router from './router'
import axios from 'axios'
import i18n from "@/api/lang";

let errMsg = i18n.t('errMsg');


// axios 配置
axios.defaults.timeout = 30000;
// axios.defaults.baseURL = "http://n4.nutptt.com";
// axios.defaults.baseURL = "http://test.nutptt.com";


//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use(config => {

  filtersParams(config.params);
  if (store.state.token) {
    config.headers.Authorization = store.state.token;
    config.headers.language = window.localStorage.getItem('language');
  }
  return config
}, error => {
  alert("错误的传参", 'fail');
  return Promise.reject(error)
});

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  response => {
    let res = response.data;
    let status = res.status;
    switch (status) {
      case 500://服务器异常错误
        Message({
          message: res.message,
          type: 'error',
          duration: 5 * 1000
        });
        break;
      case 501://token无效
        Message({
          message: res.message,
          type: 'error',
          duration: 5 * 1000
        });
        router.replace({
          path: '/',
          query: {redirect: router.currentRoute.fullPath}
        });
        break;
    }
    //匹配自定义异常
    if (errMsg[status]) {
      Message({
        message: errMsg[status].message,
        type: 'warning',
        duration: 5 * 1000
      });
    }
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 403://拒绝访问
          router.replace({
            path: '/',
            query: {redirect: router.currentRoute.fullPath}
          });
          break;
        case 404://找不到
          // router.replace({
          //   path: '/error',
          //   query: {redirect: router.currentRoute.fullPath}
          // });
          break;
      }
      return Promise.reject(error.response.data)
    }


  });


export default axios;


/**
 *  请求参数过滤空值
 *  过滤情况。
 *  1、 "" ''
 *  2、 数组序列化问题
 *
 */
function filtersParams(params) {
  for (let i in params) {
    let value = params[i];
    if (value === undefined || value === '' || value === null) {
      params[i] = undefined;
    }else{
      if(typeof(value)=='string'){
        params[i] = params[i].trim()
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/router/http.js